import UniVue from './src/uni-vue.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpUniVue = withInstall(UniVue)
export default EpUniVue
export * from './src/uni-vue'
